import React, { useContext, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import "./assets/style/main.css";
import "./assets/style/header.css";
import "./assets/style/company.css";
import "./assets/style/howToAnswerModal.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import SplashScreen from "./pages/SplashScreen";
import CodeLogin from "./pages/CodeLogin";
import Header from "./components/Header";
import CompanyName from "./pages/CompanyName";
import Thankyou from "./pages/Thank-you";
import Break from "./pages/Break";
import BreakGoing from "./pages/BreakGoing";
import BreakDone from "./pages/BreakDone";
import ThankHeader from "./components/ThankHeader";
import AdditionalInformation from "./pages/AdditionalInformation";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Lywocode from "./pages/Lywocode";
import LywoApplication from "./pages/LywoApplication";
import LywoApplicattion2 from "./pages/LywoApplicattion2";
import LywoApplication3 from "./pages/LywoApplication3";
import ApplicationStatus from "./pages/Applicationstatus";

import JobApplicationProcess from "./pages/JobApplicationProcess";

// import { AppContext } from "./context/AppContext";
import { useEffect } from "react";
import AppState from "./contaxt/AppState";
import { AppContext } from "./contaxt/AppContext";
import {
  simpleGetCall,
  simplePostCall,
  simplePostTokenCall,
} from "./api/ApiServices";
import ApiConfig from "./api/ApiConfig";
import QuestionCard from "./components/questionCard";
import ShortAssessment from "./pages/short.assement";
import Quizround from "./pages/Quizround";
import Quizthankyou from "./pages/Quizthankyou";
import Questionanswer1 from "./pages/Questionanswer1";
import LywoTechnicalQuizStatus from "./pages/LywoTechnicalQuizStatus";
import InternalBehavioralAssessment from "./pages/InternalBehavioralAssessment";
import InternalAssessmentForm from "./pages/InternalAssessmentForm";
import ScrollToTop from "./components/ScrollToTop";
import ApplicationProcess from "./pages/aplicationProcess";
import Lywoexit from "./pages/Lywoexit";
import Lywobehaviorexit from "./pages/Lywobehaviorexit";
import Lywomultipleexit from "./pages/Lywomultipleexit";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateData } from "./redux/roundtoSlice";
import { postWithAuthCallWithErrorResponse } from "./api/ApiServices";
import LywoApplicationStatus from "./pages/LywoApplicationStatus";
import QuizNoteReady from "./pages/QuizNoteReady";
import InACtiveJobCode from "./pages/inactiveJobCode";
import NotInterested from "./pages/notIntested";
import SkipQuestions from "./components/SkipQuestion";
import SmartApply from "./pages/smartApply";

function App() {
  // const {

  // } = useContext(AppContext);

  const {
    setUniqueCode,
    setIsNormal,
    getUserProgress,
    setIsNotIntersted,
    userStatus,
    handleStep,
    setIsShowMsgLgn,
    setDisplayMsg,
  } = useContext(AppContext);

  const dispatch = useDispatch();


  const navigate = useNavigate();

  const [params] = useSearchParams();

  const codeValidated = async (code) => {
    let res = await postWithAuthCallWithErrorResponse(
      ApiConfig.LOGIN_WITH_UNIQUE_CODE,
      JSON.stringify({
        jobUniqueModel: code,
      })
    );

    if (res?.json?.succeded) {
      let data = res?.json?.response[0];
      dispatch(updateData({ field: "code", value: code }));
      dispatch(updateData({ field: "id", value: data?.id }));
      dispatch(updateData({ field: "aboutJob", value: data?.aboutJob }));
      dispatch(
        updateData({ field: "aboutCompany", value: data?.aboutCompany })
      );
      dispatch(updateData({ field: "applicationType", value: data?.reason }));
      dispatch(updateData({ field: "companyname", value: data?.company }));
      dispatch(updateData({ field: "companyLogo", value: data?.companyLogo }));
      dispatch(updateData({ field: "position", value: data?.position }));
      dispatch(updateData({ field: "addInfoOne", value: data?.addInfoOne }));
      dispatch(updateData({ field: "addInfoTwo", value: data?.addInfoTwo }));
      dispatch(
        updateData({
          field: "isNormalAssesment",
          value: data?.isNormalAssesment,
        })
      );

      toast.success(res?.json?.response[0]?.message);
      setIsNormal(data?.isNormalAssesment);
      setUniqueCode(code);
    } else {

      dispatch(updateData({ field: 'position', value: res?.json?.response[0]?.position }))
      toast.error(res?.json?.response[0]?.message);
    }

    return res?.json?.succeded;
  };

  const getToken = async (userId = "", code = "") => {
    simpleGetCall(
      ApiConfig.GET_ACCESS_TOKEN_BY_USER_ID +
      `?userId=${userId}&jobcode=${code}`
    ).then((res) => {
      if (res) {
        localStorage.setItem("authToken", res.token);
        localStorage.setItem("customer_id", userId);
        localStorage.setItem("Uniquecode", code);

        dispatch(updateData({ field: "token", value: res?.token }));
        dispatch(updateData({ field: "userEmail", value: res?.email }));
        dispatch(updateData({ field: "userName", value: res?.userName }));
      }
    });
  };





  const getDetails = async (userId, code, step = 1) => {
    try {
      // let isCodeValid = await codeValidated(code);

      // if (!isCodeValid || !userId) {

      //   navigate("/InActiveJobCode")
      //   dispatch(updateData({ field: 'type', value: 'InActiveCode' }));
      //   return
      // }

      let token = await getToken(userId, code);

      let isIntersted = await userStatus(userId, code)


      if (isIntersted?.response?.isNotInterested) {

        dispatch(updateData({ field: 'currentStep', value: step }))

        setIsShowMsgLgn(true)

        setIsNotIntersted(true)

        setDisplayMsg(<p style={{
          color: "#172B4D"
        }}>You have marked the status as “Not Interested”. Please click on<span style={{ fontWeight: 'bold' }}> Interested </span>to continue.</p>)
        navigate("/JobApplicationProcess?isRedirect=" + true);

        return
      }
      handleStep(step, code)

    } catch {
      console.log("error");
    }
  };





  const hanldeNavigation = async () => {
    let code = params.get("code");
    let isCodeValid = await codeValidated(code)

    if (!isCodeValid) {
      navigate("/InActiveJobCode")
      dispatch(updateData({ field: 'type', value: 'InActiveCode' }));
      return
    }

    let id = params.get("userId");
    const step = Number(params.get("step"));


    dispatch(updateData({ field: "userId", value: id }));
    if (code && !step && !id) {
      dispatch(updateData({ field: 'fromLink', value: true }))
      // navigate('/smartApply?code=' + code + '&fromLink=' + true)
    }

    if (!step && code && id) {

      getUserProgress(code, id, true)
      return
    }

    if ((code && !step) || (code && step && !id)) {

      navigate('/smartApply?code=' + code + '&fromLink=' + true)

      // navigate(`/LoginWithCode?code=${code}`, { state: { code, fromLink: true } });
      return
    }

    if (step == 8) {
      navigate('/notInterested/' + code + '/' + id)
      return
    }

    if (code && id) {
      let stepDetls = getUserProgress(code, id, false, false, true)

      stepDetls.then((res) => {
        if (res?.succeded) {

          getDetails(id, code, res?.response?.currentStep === 1 ? 2 : res?.response?.currentStep)
        }

      })
    } else {
      navigate('/smartApply')
      // navigate("/LoginWithCode");
    }

  };

  useEffect(() => {
    hanldeNavigation();
  }, []);


  useEffect(() => {
    setUniqueCode("");
    localStorage.clear();
  }, []);


  return (
    <div>
      <ScrollToTop />

      <Routes>
        <Route
          exact
          path="/LoginWithCode"
          element={<Lywocode />}
        // element={<CodeLogin />}
        />

        {/* <Route exact path="/JobApplicationProcess" element={<JobApplicationProcess />} /> */}

        <Route
          exact
          path="/smartApply"
          element={<SmartApply />}
        />

        <Route
          exact
          path="/JobApplicationProcess"
          element={<ApplicationProcess />}
        />
        <Route exact path="/Lywocode" element={<Lywocode />} />
        <Route exact path="/LywoApplication3" element={<LywoApplication3 />} />
        <Route
          exact
          path="/ApplicationStatus"
          element={<ApplicationStatus />}
        />
        <Route
          exact
          path="/InternalAssessmentForm"
          element={<InternalAssessmentForm />}
        />
        <Route
          exact
          path="/InternalBehavioralAssessment"
          element={<InternalBehavioralAssessment />}
        />

        {/* {
          isQuizWeb ? */}
        <>
          <Route exact path="/Quizround" element={<Quizround />} />
          <Route exact path="/Quizthankyou" element={<Quizthankyou />} />
          <Route exact path="/Questionanswer1" element={<Questionanswer1 />} />
          {/* <Route exact path="/LywoApplicattion2" element={<LywoApplicattion2 />} /> */}

          {/* </>
            :


            <> */}
          <Route
            exact
            path="/AdditionalInformation"
            element={<AdditionalInformation />}
          />
          <Route
            exact
            path="/LywoTechnicalQuizStatus"
            element={<LywoTechnicalQuizStatus />}
          />
          {/* <Route exact path="/" element={<SplashScreen />} /> */}
          <Route
            exact
            path="/Thankyou"
            element={<Lywoexit />}
          // element={<Thankyou />}
          />
          <Route exact path="/Break" element={<Break />} />
          <Route exact path="/BreakGoing" element={<BreakGoing />} />
          <Route exact path="/BreakDone" element={<BreakDone />} />
          <Route exact path="/ThankHeader" element={<ThankHeader />} />
          <Route exact path="/CompanyName" element={<CompanyName />} />
          {/* <Route exact path="/LywoApplication" element={<LywoApplication />} /> */}
          <Route exact path="/acc" element={<div>Hello</div>} />
        </>
        {/* Lywo New pages seperate */}

        <Route exact path="/Lywoexit" element={<Lywoexit />} />
        <Route exact path="/LywoApplicattion2" element={<Lywobehaviorexit />} />
        <Route exact path="/LywoApplication" element={<Lywomultipleexit />} />
        <Route
          exact
          path="/LywoApplicationStatus"
          element={<LywoApplicationStatus />}
        />
        <Route
          exact
          path="/LywoApplicationStatus1"
          element={<QuizNoteReady />}
        />
        <Route
          exact
          path="/InActiveJobCode" element={<InACtiveJobCode />}
        />
        <Route path="/notInterested/:code/:id" element={<NotInterested />} />

        {/* <Route exact path='/shortAssessment' element={<ShortAssessment />} /> */}
      </Routes>

      {/* <ToastContainer/> */}
    </div>
  );
}

export default App;
